/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 25.09.13, 15:45
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { TestInstanceVO } from "./TestInstanceVO";

/**
 * Behaves like a test instance but is defined manually within the client
 */
export class DevInstanceVO extends TestInstanceVO {
    constructor() {
        super();
        this._type = "Dev";
    }
}
